/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteProcess } from '../fn/process/delete-process';
import { DeleteProcess$Params } from '../fn/process/delete-process';
import { deleteProcess1 } from '../fn/process/delete-process-1';
import { DeleteProcess1$Params } from '../fn/process/delete-process-1';
import { getProcess } from '../fn/process/get-process';
import { GetProcess$Params } from '../fn/process/get-process';
import { getProcess1 } from '../fn/process/get-process-1';
import { GetProcess1$Params } from '../fn/process/get-process-1';
import { listProcesses } from '../fn/process/list-processes';
import { ListProcesses$Params } from '../fn/process/list-processes';
import { listProcesses1 } from '../fn/process/list-processes-1';
import { ListProcesses1$Params } from '../fn/process/list-processes-1';
import { PagedModelProcessResponse } from '../models/paged-model-process-response';
import { ProcessResponse } from '../models/process-response';


/**
 * Synchronization process tracking. Processes represent individual sync runs triggered by a config. Required role: EASYLOT_ADMIN or PRICE_SYNC_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ProcessService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProcesses()` */
  static readonly ListProcessesPath = '/processes';

  /**
   * List all processes.
   *
   * Returns a paginated list of all synchronization processes across all configs.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProcesses()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProcesses$Response(params: ListProcesses$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessResponse>> {
    const obs = listProcesses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List all processes.
   *
   * Returns a paginated list of all synchronization processes across all configs.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProcesses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProcesses(params: ListProcesses$Params, context?: HttpContext): Observable<PagedModelProcessResponse> {
    const resp = this.listProcesses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProcessResponse>): PagedModelProcessResponse => r.body)
    );
  }

  /** Path part for operation `getProcess()` */
  static readonly GetProcessPath = '/process/{processId}';

  /**
   * Get process by ID.
   *
   * Returns the details and current status of a single synchronization process by its ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProcess()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcess$Response(params: GetProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessResponse>> {
    const obs = getProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process by ID.
   *
   * Returns the details and current status of a single synchronization process by its ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProcess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcess(params: GetProcess$Params, context?: HttpContext): Observable<ProcessResponse> {
    const resp = this.getProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessResponse>): ProcessResponse => r.body)
    );
  }

  /** Path part for operation `deleteProcess()` */
  static readonly DeleteProcessPath = '/process/{processId}';

  /**
   * Delete process by ID.
   *
   * Permanently deletes a synchronization process record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProcess()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProcess$Response(params: DeleteProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete process by ID.
   *
   * Permanently deletes a synchronization process record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProcess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProcess(params: DeleteProcess$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listProcesses1()` */
  static readonly ListProcesses1Path = '/config/{configId}/processes';

  /**
   * List processes for a config.
   *
   * Returns a paginated list of synchronization processes belonging to a specific config, ordered by most recent first.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProcesses1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProcesses1$Response(params: ListProcesses1$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessResponse>> {
    const obs = listProcesses1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List processes for a config.
   *
   * Returns a paginated list of synchronization processes belonging to a specific config, ordered by most recent first.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProcesses1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProcesses1(params: ListProcesses1$Params, context?: HttpContext): Observable<PagedModelProcessResponse> {
    const resp = this.listProcesses1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProcessResponse>): PagedModelProcessResponse => r.body)
    );
  }

  /** Path part for operation `getProcess1()` */
  static readonly GetProcess1Path = '/config/{configId}/process/{processId}';

  /**
   * Get process by config and process ID.
   *
   * Returns the details of a synchronization process scoped to a specific config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProcess1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcess1$Response(params: GetProcess1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessResponse>> {
    const obs = getProcess1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process by config and process ID.
   *
   * Returns the details of a synchronization process scoped to a specific config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProcess1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcess1(params: GetProcess1$Params, context?: HttpContext): Observable<ProcessResponse> {
    const resp = this.getProcess1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessResponse>): ProcessResponse => r.body)
    );
  }

  /** Path part for operation `deleteProcess1()` */
  static readonly DeleteProcess1Path = '/config/{configId}/process/{processId}';

  /**
   * Delete process by config and process ID.
   *
   * Permanently deletes a synchronization process record scoped to a specific config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProcess1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProcess1$Response(params: DeleteProcess1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProcess1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete process by config and process ID.
   *
   * Permanently deletes a synchronization process record scoped to a specific config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProcess1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProcess1(params: DeleteProcess1$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProcess1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
